










import { computed, defineComponent, PropType } from '~/utils/nuxt3-migration'
import { MakeLogoType } from '~/models/make'
import {
  BIKES_MAKES_IDS_WITH_LOGO,
  CAR_MAKES_IDS_WITH_LOGO
} from '~/constants/makemodels/logo'
import { getStaticUrl } from '~/utils/static'

const makesLogosBaseStaticPath = getStaticUrl('/nuxt-static/img/makes')

const fallbackMakeLogoImgSrc = getStaticUrl(
  '/nuxt-static/img/makes/fallback.png'
)

export default defineComponent({
  props: {
    id: {
      type: [String, Number],
      default: null
    },
    logoType: {
      type: String as PropType<MakeLogoType>,
      default: MakeLogoType.CARS
    },
    emptySpaceWhenNoLogo: {
      type: Boolean,
      default: false
    },
    sizeClass: {
      type: String,
      default: 'tw-size-5'
    }
  },
  setup(props) {
    const imgSource = computed(() => {
      if (props.logoType === 'bikes') {
        if (BIKES_MAKES_IDS_WITH_LOGO.includes(props.id)) {
          return `${makesLogosBaseStaticPath}/bikes/make-${props.id}.png`
        }

        return props.emptySpaceWhenNoLogo ? null : fallbackMakeLogoImgSrc
      }

      if (CAR_MAKES_IDS_WITH_LOGO.includes(props.id)) {
        return `${makesLogosBaseStaticPath}/cars/make-${props.id}.png`
      }

      return props.emptySpaceWhenNoLogo ? null : fallbackMakeLogoImgSrc
    })

    return { imgSource }
  }
})
